module.exports = __webpack_public_path__ + "static/media/allinone_3.a8c1009a.svg";